<script setup lang="ts">
import type { MetadataFragment } from '~/lib/graphql/graphql.ts'

const props = defineProps<{
  item: MetadataFragment
}>()

const author = computed(() => {
    return getAuthor(props.item)
})
</script>

<template>
  <PLink
    v-if="author"
    id="author"
    :key="author.id"
    :content="[{ id: author.id, type: author.attributes['type'] }]"
    :to="'/people/' + author.slug"
    class="w-full flex flex-col justify-center justify-items-center font-serif no-underline text-center"
  >
    <ContentImage
      :item="author"
      :alt="author.name || ''"
      relationship="image.featured.square"
      picture-class="w-20 h-20 m-0 p-0 rounded-full overflow-hidden justify-self-center align-self-center self-center"
      class="object-cover w-20 h-20 m-0 p-0 rounded-full overflow-hidden"
    />
    <div class="font-bold mt-4 mb-6">
      {{ author.name }}
    </div>
    <div class="italic">
      {{ author.attributes.bio }}
    </div>
  </PLink>
</template>
